const convertKilogramsToPounds = (kg: number) => Math.round(kg * 2.205);
const convertPoundsToKilograms = (lbs: number) => Math.round(lbs / 2.205);

export { convertKilogramsToPounds, convertPoundsToKilograms };
